export default {
    data() {
        return {
            moveCursorElemData: {
                isDown: false,
                offset: [0, 0],
                mousePosition: null,
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        }
    },
    created() {},

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.moveCursorElemInit()
            }, 500)
        })
    },
    beforeDestroy() {
        this.moveCursorElemDestroy()
    },
    methods: {
        moveCursorElemDestroy() {
            this.$refs.moveCursor.removeEventListener('mousedown', this.moveCursorElemMousedown)
            document.removeEventListener('mouseup', this.moveCursorElemMouseup)
            document.removeEventListener('mousemove', this.moveCursorElemMousemove)
            window.removeEventListener('resize', this.getSizeWindow)
        },
        moveCursorElemInit() {
            if (!this.$refs.moveCursor) return
            this.$refs.moveCursor.addEventListener('mousedown', this.moveCursorElemMousedown)
            document.addEventListener('mouseup', this.moveCursorElemMouseup, true)
            document.addEventListener('mousemove', this.moveCursorElemMousemove, true)
            window.addEventListener('resize', this.getSizeWindow)
        },
        getSizeWindow() {
            this.moveCursorElemData.window.width = window.innerWidth
            this.moveCursorElemData.window.height = window.innerHeight
        },
        moveCursorElemMousemove(e) {
            //e.preventDefault()

            if (this.moveCursorElemData.isDown) {
                this.moveCursorElemData.mousePosition = {
                    x: e.clientX,
                    y: e.clientY
                }

                let left = this.moveCursorElemData.mousePosition.x
                let top = this.moveCursorElemData.mousePosition.y

                left = (left / this.moveCursorElemData.window.width) * 100
                top = (top / this.moveCursorElemData.window.height) * 100

                if (left > 100) left = 100
                if (top > 100) top = 100
                if (left < 0) left = 0
                if (top < 0) top = 0

                this.$store.commit('design/setLocalStorage', {
                    left,
                    top
                })
            }
        },
        moveCursorElemMousedown(e) {
            //if(e.target!==this.$refs.moveCursor) return
            this.moveCursorElemData.isDown = true
            this.moveCursorElemData.offset = [e.clientX, e.clientY]
        },
        moveCursorElemMouseup() {
            this.moveCursorElemData.isDown = false
        }
    }
}
